import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import {ApiService} from '../../shared/services/api.service';
import {InternalService} from '../../shared/services/internal.service';

import {ActivatedRoute, Router} from '@angular/router';


@Component({
  selector: 'app-services',
  templateUrl: 'services.component.html',
  styleUrls: ['services.component.css'],
})
export class ServicesComponent implements OnInit {
  tabIndex: any;
  categories: any = [];
  loader: any = true;
  id: any = 0;

  constructor(
    public apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public internalService: InternalService
  ) {
  }

  ngOnInit() {
    this.getAllCategories();
    this.id = Number(this.route.snapshot.params.id);

  }

  getAllCategories() {
    this.apiService.getAllCategories().subscribe((res: any) => {
      // console.log(res);
      this.categories = res.res;
      for (let item of this.categories) {
        if (item.icon) {
          this.internalService.getMd5(item.icon).then(result => {
            item.iconImage = result;
          });
        }
        for (let subCat of item.subCategoies) {
          if (subCat.image) {
            this.internalService.getMd5(subCat.image).then(result => {
              subCat.base64 = result;
            });
          }
        }
        if (res.stu === 1) {
          this.loader = false;
          setTimeout(() => {
            if (this.id!==0) {
              document.querySelector('#category' + this.id).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }, 500);
        }
      }
    });
  }

  ScrollIntoView(elem: string) {
    // console.log(elem);
    document.querySelector(elem).scrollIntoView({behavior: 'smooth', block: 'start'});
  }
}
